import Head from 'next/head';
import React from 'react';

import { initSravniTM } from '@sravni/utils/lib/analytics';
import { ISravniTMOptions } from '@sravni/utils/lib/analytics';

export interface ICommonHeadProps {
  analyticsOptions?: { enabled: boolean; isWidget: boolean } & ISravniTMOptions;
}

const decorateAnalyticsOptions = (
  options: ICommonHeadProps['analyticsOptions'],
): ICommonHeadProps['analyticsOptions'] => {
  if (!options) return undefined;

  return {
    ...options,
  };
};

export const WidgetHead = (props: ICommonHeadProps) => {
  const { analyticsOptions: analyticsOptionsOutside } = props;

  const analyticsOptions = decorateAnalyticsOptions(analyticsOptionsOutside ?? undefined);

  const isAnalyticsEnabled = analyticsOptions && analyticsOptions.enabled;

  return (
    analyticsOptionsOutside.isWidget && (
      <Head>
        <meta name="viewport" content="width=device-width, initial-scale=1, shrink-to-fit=no" />
        <meta httpEquiv="X-UA-Compatible" content="IE=edge" />
        <meta name="mobile-web-app-capable" content="yes" />

        {isAnalyticsEnabled && analyticsOptions && (
          <script id="analytics-initialization">{initSravniTM(analyticsOptions)}</script>
        )}
      </Head>
    )
  );
};
